import React, { useLayoutEffect, useState, useContext } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import InputImgBigger from 'components/InputImgBigger';
import SimpleInput from 'components/SimpleInput';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import SelectInput from 'components/SelectInput';
import { optionsRedirectType } from 'utils/optionsInputs';
import { generateUid } from 'utils/functions';
import { verifyIfFormCanSave, returListOptionsDynamicPage } from './functions';
import SystemNotifyContext from 'context/SystemNotifyContext';
import DynamicPageContext from 'context/DynamicPage';
import { Storie } from 'types/InputsStoriesCarouselProps';

interface FormAddBannerProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	storieToEdit: Storie | null;
	functionToGetDataAboutBanner: any;
	withTitle?: boolean;
}

export interface DataFormAddBannerProps {
	idFront: string | number;
	banner: { id: string; relativePath: string } | null;
	redirectType: string;
	redirectValue: string;
	title: string;
}

const initialState: Storie = {
	title: '',
	idFront: '',
	image: { id: '', path: '' },
	redirect: {
		type: '',
		value: ''
	},
	query: ''
};

export default function FormAddStorie({
	isOpen,
	setIsOpen,
	storieToEdit,
	functionToGetDataAboutBanner = () => {},
	withTitle = true
}: FormAddBannerProps) {
	initialState.idFront = generateUid(); //isso é pra gerar um id diferente todas as vezes que um novo banner é criado

	const { handleNotify } = useContext(SystemNotifyContext);
	const { dynamicPagesList } = useContext(DynamicPageContext);

	const [dataForm, setDataForm] = useState<Storie>(initialState);
	const [optionsDynamicScreen, setOptionsDynamicScreen] = useState<
		SelectInputItemProps[]
	>([]);

	function findOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	function saveStorie() {
		const canSave = verifyIfFormCanSave(dataForm, handleNotify);

		if (canSave) {
			functionToGetDataAboutBanner(dataForm);
			setIsOpen(false);
			setDataForm(initialState);
		}
	}

	function cancel() {
		setIsOpen(false);
		setDataForm(initialState);
	}

	//usando para quando estiver em modo de edição
	useLayoutEffect(() => {
		setTimeout(() => {
			if (storieToEdit !== null) {
				const bannerToEdit: Storie = {
					idFront: storieToEdit?.idFront || '',
					image: {
						id: storieToEdit.image.id,
						path: storieToEdit.image.path
					},
					redirect: {
						type: storieToEdit.redirect.type,
						value: storieToEdit.redirect.value
					},
					title: storieToEdit.title,
					query: storieToEdit.query
				};

				setDataForm(bannerToEdit);
			}
		}, 100);
	}, [storieToEdit]);

	//cria lista de opções de pagínas dinamicas em um estado para evitar reenderização
	useLayoutEffect(() => {
		setOptionsDynamicScreen(returListOptionsDynamicPage(dynamicPagesList));
	}, []);

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				setIsOpen((value) => !value);
				setDataForm(initialState);
			}}
			title={storieToEdit === null ? 'Adicionar Storie' : 'Editar Storie'}
			buttonClose={false}
		>
			<S.container>
				{withTitle && (
					<SimpleInput
						label="Título"
						initialValue={dataForm.title}
						getValue={(value: string) => {
							setDataForm((obj) => ({ ...obj, title: value }));
						}}
					/>
				)}

				<S.twoInputs>
					<SelectInput
						list={optionsRedirectType}
						getValue={(value: SelectInputItemProps | '') => {
							setDataForm((obj) => ({
								...obj,
								redirect: {
									...obj.redirect,
									type: value === '' ? value : (value?.id as string)
								}
							}));
						}}
						initialValue={
							dataForm.redirect.type === ''
								? optionsRedirectType[0]
								: findOptionOnListById(
										dataForm.redirect.type || '',
										optionsRedirectType
									)
						}
						label="Tipo de redirecionamento"
					/>

					{dataForm.redirect.type !== 'app_screen' && (
						<SimpleInput
							label="Valor do redirecionamento *"
							initialValue={dataForm.redirect.value}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									redirect: { ...obj.redirect, value: value }
								}));
							}}
						/>
					)}

					{dataForm.redirect.type === 'app_screen' && (
						<SelectInput
							list={optionsDynamicScreen}
							getValue={(value: SelectInputItemProps | '') => {
								setDataForm((obj) => ({
									...obj,
									redirect: {
										...obj.redirect,
										value: value === '' ? value : (value?.id as string)
									}
								}));
							}}
							initialValue={
								dataForm.redirect.value === ''
									? ''
									: findOptionOnListById(
											dataForm.redirect.value || '',
											optionsDynamicScreen
										)
							}
							label="Valor Redirecionamento *"
						/>
					)}
				</S.twoInputs>

				<SimpleInput
					label="Query"
					initialValue={dataForm.query}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, query: value }));
					}}
				/>

				<InputImgBigger
					label="Banner"
					idImagem="FormAddBanner"
					initialImage={dataForm.image === null ? '' : `${dataForm.image.path}`}
					getImage={(value: any) => {
						setDataForm((obj) => {
							return {
								...obj,
								image: {
									id: value?.id || generateUid(),
									path: value?.url || value.relativePath
								}
							};
						});
					}}
				/>

				<S.containerBtns>
					<S.cancel onClick={cancel}>Cancelar</S.cancel>
					<S.save onClick={saveStorie}>Salvar</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
